export const EventName =
	{
		DOM_CONTENT_LOADED: "DOMContentLoaded",
		WINDOW_SCROLL: "scroll",
		WINDOW_RESIZE: "resize"
	};